module.exports = __webpack_public_path__ + "images/emoji/battery.966dfae7b60c2996e65a.png";